export default __webpack_public_path__ + "static/media/placeholder_business03-it-mobile.2eb8766d.png";